import React from 'react';
import { Clock } from 'lucide-react';
import { ScheduleTable } from '../../components/ScheduleTable';
export function FreeTrialSchedule() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1585">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1586">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1587">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1588">
            <Clock className="w-3.5 h-3.5" data-id="element-1589" />
            Class Times
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-1590">
            When Storm Classes Run
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1591">
            A quick look at the weekly schedule. Not sure which one fits?
            Mention your goals on the form and a coach will recommend a time.
          </p>
        </div>
        <ScheduleTable data-id="element-1592" />
      </div>
    </section>;
}